import Backbone from 'backbone';

module.exports = Backbone.Model.extend({
  defaults: {
    activate: 0,
    select: 0,
    resetId: 0,
    label: '',
    content: '',
    category: '',
    attributes: {}
  },

  initialize(opts = {}) {}
});
